module.exports = __webpack_public_path__ + "img/mu.ead42a4f.svg";